// The files chosen for a bulk upload (15/10/2026), kept between the page
// that lists them and the page that sends them: a Turbo visit keeps the
// script alive, a reload does not (the page then asks for them again).
const filesByUpload = new Map();

export function keepFiles(uploadId, files) {
  filesByUpload.set(String(uploadId), files);
}

export function takeFiles(uploadId) {
  return filesByUpload.get(String(uploadId)) || [];
}

// Every file of a drop, the folders opened (one level after another).
export async function filesFromDrop(dataTransfer) {
  const entries = Array.from(dataTransfer.items || [])
    .map((item) => (item.webkitGetAsEntry ? item.webkitGetAsEntry() : null))
    .filter(Boolean);
  if (entries.length === 0) return Array.from(dataTransfer.files || []);

  const files = [];
  const walk = async (entry) => {
    if (entry.isFile) {
      files.push(await new Promise((resolve, reject) => entry.file(resolve, reject)));
    } else if (entry.isDirectory) {
      const reader = entry.createReader();
      // readEntries hands a folder over in slices of 100.
      for (;;) {
        const batch = await new Promise((resolve, reject) => reader.readEntries(resolve, reject));
        if (batch.length === 0) break;
        for (const child of batch) await walk(child);
      }
    }
  };
  for (const entry of entries) await walk(entry);
  return files;
}

// Hidden files of a folder (.DS_Store, Thumbs.db) are not the school's.
export function visibleFiles(files) {
  return files.filter((file) => !file.name.startsWith(".") && file.name !== "Thumbs.db" && file.name !== "desktop.ini");
}

export function humanSize(bytes) {
  const units = ["o", "Ko", "Mo", "Go"];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toLocaleString(undefined, { maximumFractionDigits: unit === 0 ? 0 : 1 })} ${units[unit]}`;
}

export function interpolate(text, values) {
  return String(text || "").replace(/%\{(\w+)\}/g, (_, key) => (values[key] ?? ""));
}

export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || "";
}
